<template>
  <div id="home">
    <Themes/>
    <!-- <ButtonUp /> -->
  </div>
</template>

<script>
    import Themes from '../components/main/Themes.vue';
    import ButtonUp from '../components/misc/ButtonUp.vue';
    import { mapGetters } from 'vuex';

    export default {
        name: 'Home',
        components: {
            Themes,
        },
        computed:{
            ...mapGetters(["current"])
        },
        created() {
            //console.log("rerender");
            if (!(this.$route.query && this.$route.query.learn)) {
                document.documentElement.style.overflow = 'hidden'
            }
        },
        beforeRouteEnter (to, from, next) {
            if (!(to.query && to.query.learn)) { //window.innerWidth > 599
                document.documentElement.style.overflow = 'hidden'
            }
            next()
        },
        beforeRouteLeave (to, from, next) {
            document.documentElement.style.overflow = ''
            next()
        }
    }
</script>

<style lang="scss" scoped>
  #home{
    opacity: 1;
  }
</style>